import React from "react";
import { useRoth } from "./useHouseLive";

const sgn = (v) => `${v >= 0 ? "+" : ""}${Number(v).toFixed(2)}%`;

const Movers = ({ title, rows, up }) => (
  <div className="min-w-0">
    <p className="fc-label mb-[0.2em]">{title}</p>
    {rows.length ? rows.map((r) => (
      <div key={r.symbol} className="flex items-baseline justify-between gap-[0.4em] border-t border-white/5 py-[0.35em]" data-testid={`roth-${up ? "gainer" : "loser"}-${r.symbol}`}>
        <b className="nx-orbitron text-[1.2em] text-cyan-50 truncate">{r.symbol}</b>
        <b className={`fc-num text-[1.25em] ${up ? "fc-gain" : "fc-loss"}`}>{sgn(r.pct)}</b>
      </div>
    )) : <p className="fc-num text-[1em] text-cyan-200/50">none today</p>}
  </div>
);

export const RothCard = () => {
  const d = useRoth();
  if (d && !d.connected) return <section className="fc-panel fx-glow p-[0.6em]" data-testid="roth-card"><p className="fc-label">Roth IRA</p><p className="fc-num text-[1.1em] text-cyan-200/70 mt-[0.3em]" data-testid="roth-not-connected">Roth IRA not connected</p></section>;
  const up = (d?.day_pct ?? 0) >= 0;
  return (
    <section className="fc-panel fx-glow flex-1 min-h-0 p-[0.6em] flex flex-col justify-around overflow-hidden" data-testid="roth-card">
      <div className="flex items-baseline justify-between gap-[0.5em] whitespace-nowrap">
        <p className="fc-label">Roth IRA</p>
        <p className={`fc-num font-bold text-[2.8em] leading-none ${up ? "fc-gain" : "fc-loss"}`} data-testid="roth-day-pct">{d?.day_pct == null ? "—" : `${up ? "▲" : "▼"} ${sgn(d.day_pct)}`}</p>
      </div>
      <div className="grid grid-cols-2 gap-[0.8em]">
        <Movers title="Top gainers" rows={d?.gainers || []} up />
        <Movers title="Top losers" rows={d?.losers || []} />
      </div>
    </section>
  );
};
